import { format } from 'date-fns'

export const utilsMixin = {
  data() {
    return {
      isClipboardSupported: true,
    }
  },
  methods: {
    formatCurrency(val) {
      let formatter = new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
        minimumFractionDigits: 2,
      });
      return formatter.format(val);
    },
    formatDate(date, syntax) {
      return format(date, syntax)
    },
    capitaliseFirstLetter(word){
      return word.charAt(0).toUpperCase() + word.slice(1);
    },
    copyToClipBoard(text) {
      if (!navigator.clipboard) {
        return;
      }
      navigator.clipboard
        .writeText(text)
        .then(() => {
          console.log("Text copied to clipboard...");
        })
        .catch((err) => {
          console.log("Something went wrong", err);
        });
    },
  },
  mounted() {
    this.isClipboardSupported = navigator.clipboard !== null && navigator.clipboard !== undefined;
  }
}

